import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Audience } from '../components/Audience';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { ChatAvatar } from '../components/ChatAvatar';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-327">
      <Header data-id="element-328" />
      <main data-id="element-329">
        <Hero data-id="element-330" />
        <Services data-id="element-331" />
        <Audience data-id="element-332" />
        <Process data-id="element-333" />
        <Testimonials data-id="element-334" />
        <CTASection data-id="element-335" />
      </main>
      <Footer data-id="element-336" />
      <ChatAvatar data-id="element-337" />
    </div>;
}